import { DateTime } from "luxon";
import { PersistableCalendarEvent } from "shared/guide-content/rich-blocks/calendar-utils/types";

export const getLatestSelectionOrSuggestionDate = ({
  selections = [],
  suggestions = [],
}: {
  selections?: PersistableCalendarEvent[];
  suggestions?: PersistableCalendarEvent[];
}) => {
  if (selections.length) {
    const mostRecentSelection = selections.reduce((mostRecent, current) => {
      if (current.start && mostRecent.start) {
        return DateTime.fromISO(current.start) >
          DateTime.fromISO(mostRecent.start)
          ? current
          : mostRecent;
      }
      return mostRecent;
    }, selections[0]);
    return mostRecentSelection.start
      ? new Date(mostRecentSelection.start)
      : new Date();
  }
  if (suggestions.length) {
    const mostRecentSuggestion = suggestions.reduce((mostRecent, current) => {
      if (current.start && mostRecent.start) {
        return DateTime.fromISO(current.start) >
          DateTime.fromISO(mostRecent.start)
          ? current
          : mostRecent;
      }
      return mostRecent;
    }, suggestions[0]);
    return mostRecentSuggestion.start
      ? new Date(mostRecentSuggestion.start)
      : new Date();
  }
  return new Date();
};

export const getPlaceholderTitle = () => {
  return `Request for availability`;
};
